export const Customers = {
    LOADING_CUSTOMERS_LIST: "LOADING_CUSTOMERS_LIST",
    GET_CUSTOMERS_LIST: "GET_CUSTOMERS_LIST",
  };